import { render, staticRenderFns } from "./newsletterIcon.vue?vue&type=template&id=09fcd462&"
var script = {}
import style0 from "./newsletterIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('09fcd462', component.options)
    } else {
      api.reload('09fcd462', component.options)
    }
    module.hot.accept("./newsletterIcon.vue?vue&type=template&id=09fcd462&", function () {
      api.rerender('09fcd462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/newsletterIcon.vue"
export default component.exports